import styles from './FJFaceSwapLeft.module.less';
import PropTypes from 'prop-types';
import FJGenerateButton from '../../../common/components/FJGenerateButton/FJGenerateButton';
import FJImageUpload from '../FJImageUpload/FJImageUpload';
import PeopleIcon from '../../../assets/svg/people.svg?react';
import ClothesIcon from '../../../assets/svg/clothes.svg?react';
import FaceIcon from '../../../assets/svg/face.svg?react';
import ToFaceIcon from '../../../assets/svg/to-face.svg?react';

import ToFaceSmallIcon from '../../../assets/svg/to-face-small.svg?react';
import ClothesSmallIcon from '../../../assets/svg/clothes-small.svg?react';
import PeopleSmallIcon from '../../../assets/svg/people-small.svg?react';
import FaceSmallIcon from '../../../assets/svg/face-small.svg?react';
import FJAppLeft from '../../FJMainPreview/FJAppLeft/FJAppLeft';
import FJVerticalScroller from '../../../common/components/FJScroller/FJVerticalScroller';
import FJFaceSwapTryThose from '../FJFaceSwapTryThose/FJFaceSwapTryThose';
import FJLocalStore from '../../../store/FJLocalStore';

const FJFaceSwapLeft = props => {
    const {
        onGenerate,
        taskStatus,
        freeNumCreation,
        creditNumber,
        uploadImageInfo,
        onUploadImage,
        openMediaLibrary,
        onUploadTargetImage,
        isProjectLoading,
        targetUploadImageInfo,
        onOriginTryThose,
        onTargetTryThose,
        originCurLoadName,
        targetCurLoadName,
    } = props;
    const isFree = freeNumCreation > 0 && creditNumber < 2;
    const isFace = true;
    const defaultUploadIcon = isFace ? <FaceIcon /> : <PeopleIcon />;
    const defaultUploadSmallIcon = isFace ? <FaceSmallIcon /> : <PeopleSmallIcon />;
    const defaultExchangeUploadIcon = isFace ? <ToFaceIcon /> : <ClothesIcon />;
    const defaultExchangeUploadSmallIcon = isFace ? <ToFaceSmallIcon /> : <ClothesSmallIcon />;

    const _openMediaLibrary = (isOriginalImage = false) => {
        if (openMediaLibrary) openMediaLibrary(isOriginalImage);
    };

    return (
        <FJAppLeft>
            <FJVerticalScroller className={styles.scroller}>
                <div className={styles.origin_upload_box}>
                    <div className={styles.origin_upload_box_title}>{FJLocalStore._('upload-original-image')}</div>
                    <FJImageUpload
                        openMediaLibrary={() => _openMediaLibrary(true)}
                        imageInfo={uploadImageInfo}
                        uploadImg={file => {
                            onUploadImage(file);
                        }}
                        defaultIcon={defaultUploadIcon}
                        smallIcon={defaultUploadSmallIcon}
                        className={styles.origin_upload_box_upload}
                        uploadTextClassName={styles.origin_upload_box_upload_text}
                        uploadText='retain-areas-outside-of-the-face-in-here'
                    />
                    <div className={styles.try_those_images_title}>{FJLocalStore._('try-these-images')}</div>
                    <FJFaceSwapTryThose onTryThose={onOriginTryThose} curLoadName={originCurLoadName} />
                </div>

                <div className={styles.line}></div>

                <div className={styles.target_upload_box}>
                    <div className={styles.target_upload_box_title}>{FJLocalStore._('upload-target-image')}</div>
                    <FJImageUpload
                        openMediaLibrary={() => _openMediaLibrary(false)}
                        imageInfo={targetUploadImageInfo}
                        uploadImg={file => {
                            onUploadTargetImage(file, true);
                        }}
                        defaultIcon={defaultExchangeUploadIcon}
                        smallIcon={defaultExchangeUploadSmallIcon}
                        className={styles.target_upload_box_upload}
                        uploadTextClassName={styles.target_upload_box_upload_text}
                        uploadText='swap-face-from-original-image-in-here'
                    />
                    <div className={styles.try_those_images_title}>{FJLocalStore._('try-these-images')}</div>
                    <FJFaceSwapTryThose onTryThose={onTargetTryThose} type='target' curLoadName={targetCurLoadName} />
                </div>
            </FJVerticalScroller>

            <FJGenerateButton
                className={styles.generate_btn}
                onClick={onGenerate}
                taskStatus={taskStatus}
                freeNumCreation={freeNumCreation}
                isFree={isFree}
                useCredit={2}
                isProjectLoading={isProjectLoading}
            />
        </FJAppLeft>
    );
};
FJFaceSwapLeft.propTypes = {
    onGenerate: PropTypes.func,
    taskStatus: PropTypes.string,
    freeNumCreation: PropTypes.number,
    creditNumber: PropTypes.number,
    uploadImageInfo: PropTypes.object,
    uploadExchangeImageInfo: PropTypes.object,
    openMediaLibrary: PropTypes.func,
    onUploadImage: PropTypes.func,
    selectedStyle: PropTypes.string,
    onSelectStyle: PropTypes.func,
    isProjectLoading: PropTypes.bool,
    onUploadTargetImage: PropTypes.func,
    targetUploadImageInfo: PropTypes.object,
    onOriginTryThose: PropTypes.func,
    onTargetTryThose: PropTypes.func,
    originCurLoadName: PropTypes.string,
    targetCurLoadName: PropTypes.string,
};
export default FJFaceSwapLeft;
